import { ApiTicketCategoryService } from "./../../../../services/api/api-ticket-category-service.service";
import { IPlatform } from "./../../../../interfaces/i-platform";
import { ApiPlatformService } from "./../../../../services/api/api-platform-service.service";
import { Component, Inject, OnInit } from "@angular/core";
import {
    FormControl,
    FormGroup,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ITicketCategory } from "app/interfaces/i-ticket-category";
import { GoogleAnalyticsService } from "app/services/analytics/google-analitics-service";
import { LocalStorageService } from "app/services/local-storage/local-storage.service";
import moment from "moment";
import { Subject } from "rxjs";
import { debounceTime, switchMap, takeUntil } from "rxjs/operators";
import { TicketServices } from "../../../../enums/ticket-services.enum";
import { ApiCalendarService } from "../../../../services/api/api-calendar-service";
import { TimeToNowValidator } from "../../../../services/MaterialValidator/TimeToNowValidator";
import { assign } from "lodash";
import {
    MAT_DATE_FORMATS,
    DateAdapter,
    MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateValidator } from "app/services/MaterialValidator/DateScheduledValidator";
import { environment } from "environments/environment";

export const MY_FORMATS = {
    parse: {
        dateInput: "DD/MM/YYYY",
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
    },
};

@Component({
    standalone: false,
    selector: "fuse-dialog-new-ticket",
    templateUrl: "./dialog-new-ticket.component.html",
    styleUrls: ["./dialog-new-ticket.component.scss"],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
// tslint:disable-next-line:component-class-suffix
export class DialogNewTicket implements OnInit {
    public formGroupVideoChatScheduled: FormGroup;
    public formGroup: UntypedFormGroup;
    public categories: ITicketCategory[];
    public duration = [];
    public isScheduled: boolean = false;
    public willBeOpened: boolean = true;
    public minHoursForTicketSchedulation: number =
        environment.minHoursForTicketSchedulation;
    public is_remote: boolean =
        environment.showRemoteOptionForTicketSchedulation;
    /** Evita che un doppio click rapido su "Procedi" invii due volte la richiesta */
    public isSubmitting: boolean = false;

    private _destroy$: Subject<void> = new Subject();

    public today = new Date();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogNewTicket>,
        private storage: LocalStorageService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private apiCalendarService: ApiCalendarService,
        private platformService: ApiPlatformService,
        private ticketCategoryService: ApiTicketCategoryService,
    ) {
        for (let i = 30; i <= 600; i += 30) {
            this.duration.push(i);
        }
        this.isScheduled = data.type === "scheduled";

        this.formGroup = new UntypedFormGroup({
            phone: new UntypedFormControl("", [Validators.required]),
            category: new UntypedFormControl("", [Validators.required]),
            description: new UntypedFormControl("", [Validators.required]),
        });

        this.formGroupVideoChatScheduled = new FormGroup({
            schedule_hours: new FormControl(
                "",
                [Validators.required].concat(
                    !this.isScheduled ? [TimeToNowValidator.IsBefore] : [],
                ),
            ),
            duration: new FormControl(30, [Validators.required]),
            id_category: new FormControl("", [Validators.required]),
            note: new FormControl(),
        });

        if (this.isScheduled) {
            this.formGroupVideoChatScheduled.addControl(
                "date",
                new FormControl(false, [
                    Validators.required,
                    DateValidator.MinData,
                ]),
            );

            this.formGroupVideoChatScheduled.addControl(
                "schedulationDetail",
                new FormGroup({
                    is_remote: new FormControl(true, [Validators.required]),
                }),
            );

            this.formGroupVideoChatScheduled
                .get("schedulationDetail.is_remote")
                .valueChanges.subscribe((is_remote) => {
                    if (is_remote) {
                        (
                            this.formGroupVideoChatScheduled.get(
                                "schedulationDetail",
                            ) as FormGroup
                        ).removeControl("detail");
                    } else {
                        (
                            this.formGroupVideoChatScheduled.get(
                                "schedulationDetail",
                            ) as FormGroup
                        ).addControl(
                            "detail",
                            new FormGroup({
                                city: new FormControl(null, [
                                    Validators.required,
                                ]),
                                address: new FormControl(null, [
                                    Validators.required,
                                ]),
                                reason: new FormControl(null, []),
                            }),
                        );
                    }
                });

            this.formGroupVideoChatScheduled.valueChanges
                .pipe(debounceTime(500), takeUntil(this._destroy$))
                .subscribe(() => {
                    this.checkScheduledIsOpened();
                });
        }
    }

    ngOnInit(): void {
        this.googleAnalyticsService.pageEmitter("NewTicketPage");

        this.platformService
            .getOneById(environment.platform_id)
            .pipe(
                switchMap((platform: IPlatform) => {
                    return this.ticketCategoryService.find(
                        platform.id_tenant.toString(),
                    );
                }),
            )
            .subscribe((categories) => {
                this.categories = categories;
            });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
    }

    checkScheduledIsOpened(): void {
        if (
            this.isScheduled &&
            this.formGroupVideoChatScheduled.get("schedule_hours").value &&
            this.formGroupVideoChatScheduled.get("date").value &&
            this.formGroupVideoChatScheduled.get("duration").value
        ) {
            const schedule_hours_spllited = this.formGroupVideoChatScheduled
                .get("schedule_hours")
                .value.split(":");
            const dateForCheck: Date = moment(
                this.formGroupVideoChatScheduled.get("date").value,
            )
                .set({
                    hours: schedule_hours_spllited[0],
                    minutes: schedule_hours_spllited[1],
                })
                .add(
                    this.formGroupVideoChatScheduled.get("duration").value,
                    "minutes",
                )
                .toDate();

            this.apiCalendarService
                .apiActiveInTheFuture(
                    TicketServices.VIDEOCHAT_SCHEDULED,
                    dateForCheck,
                )
                .subscribe((opened) => (this.willBeOpened = !!opened));
        }
    }

    setMyStyles(): any {
        const style = {
            color: this.data.color,
        };
        return style;
    }

    onYesClick(): void {
        if (this.isSubmitting) {
            return;
        }

        if (this.data.type === "scheduled") {
            if (this.formGroupVideoChatScheduled.valid) {
                const updatedModalData = this.formGroupVideoChatScheduled.value;
                const schedulationDetail: any =
                    updatedModalData["schedulationDetail"];
                if (schedulationDetail && !schedulationDetail?.is_remote) {
                    updatedModalData["schedulationDetail"] = Object.assign(
                        {},
                        schedulationDetail,
                        schedulationDetail["detail"],
                    );
                    delete updatedModalData["schedulationDetail"]["detail"];
                }

                this.googleAnalyticsService.eventEmitter(
                    "NewTicketPage",
                    "New Ticket Creation Successfully",
                );
                this.isSubmitting = true;
                this.dialogRef.close(updatedModalData);
            }
        } else {
            if (this.formGroup.valid) {
                const updatedModalData = assign(
                    {},
                    {
                        phone: this.formGroup.controls.phone.value,
                        category: this.formGroup.controls.category.value,
                        description: this.formGroup.controls.description.value,
                    },
                );
                this.googleAnalyticsService.eventEmitter(
                    "NewTicketPage",
                    "New Ticket Creation Successfully",
                );
                this.isSubmitting = true;
                this.dialogRef.close(updatedModalData);
            }
        }
    }
}
